import React, { useState } from 'react';
import styled from 'styled-components';
import { FileDownload } from '~/ui/assets/icons';
import { Image, ImageModal, ImageContent, PDFContent, VideoContent } from '../Media/Media.styled';
import { AudioPlayer } from './AudioPlayer';

const mediaType: Record<string, string> = {
  'application/pdf': 'PDF',
  'image/jpeg': 'Image',
  'image/png': 'Image',
  'image/jpg': 'Image',
  'image/gif': 'Image',
  'image/webp': 'Image',
  'audio/ogg': 'Audio',
  'audio/mpeg': 'Audio',
  'audio/mp4': 'Audio',
  'audio/aac': 'Audio',
  'audio/webm': 'Audio',
  'video/mp4': 'Video',
};

const GenericFileLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
`;

export interface ContentMediaProps {
  content: {
    media_url: string;
    storage_key: string;
    content_type: string;
    filename?: string;
  };
}

export function ContentMedia({ content }: ContentMediaProps) {
  const [isOpen, setIsOpen] = useState(false);

  const normalizedType = content.content_type?.split(';')[0].trim();
  const type = mediaType[normalizedType];

  return (
    <>
      {type === 'Image' && <Image image={content.media_url} onClick={() => setIsOpen(true)} />}

      {type === 'PDF' && (
        <FileDownload width={38} height={48} onClick={() => setIsOpen(true)} style={{ cursor: 'pointer' }} />
      )}

      {type === 'Audio' && <AudioPlayer src={content.media_url} contentType={content.content_type} />}

      {type === 'Video' && (
        <VideoContent controls>
          <source src={content.media_url} />
          <track src={content.media_url} kind="captions" label="Portugues" />
        </VideoContent>
      )}

      {isOpen && (
        <ImageModal onClick={() => setIsOpen(false)}>
          {type === 'Image' && <ImageContent src={content.media_url} />}
          {type === 'PDF' && <PDFContent src={content.media_url} type="application/pdf" />}
        </ImageModal>
      )}

      {!type && content.media_url && (
        <GenericFileLink href={content.media_url} target="_blank" rel="noopener noreferrer">
          <FileDownload width={24} height={24} />
          {content.filename || 'Arquivo'}
        </GenericFileLink>
      )}
    </>
  );
}
